import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "layout-login__state-desc" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = ["href"]

import { ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreDonePage',
  setup(__props, { expose: __expose }) {

const route = useRoute();
const router = useRouter();

/**
 * Эмейл, указанный на предыдущей странице
 */
const onMovementRestoreEmail = ref(route.params.email);


/**
 * Блок элемента контента
 */
 const $currentComponentWrapper = ref(null);

/**
 * Текущая высота элемента контента
 */
const currentHeightComponent = ref(null);

/**
 * К логину
 */
const toLoginPage = () => {
  router.push("/login");
};


onMounted(() => {
  currentHeightComponent.value = $currentComponentWrapper.value?.offsetHeight;
});

__expose({
  changerMethodFromComponent: toLoginPage,
  currentHeightComponent: currentHeightComponent,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "layout-login__body",
    ref_key: "$currentComponentWrapper",
    ref: $currentComponentWrapper
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(" Новый пароль успешно отправлен "),
      _hoisted_2,
      _createTextVNode(" на "),
      _createElementVNode("a", {
        href: `mailto:${onMovementRestoreEmail.value}`
      }, _toDisplayString(onMovementRestoreEmail.value), 9, _hoisted_3)
    ])
  ], 512))
}
}

})